/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @TODO remove "Vue.extend" from module export
 */
const __vue_script__ = Vue.extend({

  /** @since 3.8.6 */
  name: 'form-header',

  props: {
    headers: {
      type: Array,
      default: []
    },
    currentid: {
      type: String
    },
    update: {
      type: Boolean
    },
    valid: {
      type: Boolean
    }
  },
  methods: {
    click(id) {
      /**
       * @deprecated since 3.6.2
       * This was used when form headers has more than one (case relation)
       */
      if (id !== this.currentid && this.headers.length > 1) {
        this.$emit('clickheader', id);
      }
    },
    resizeForm(perc) {
      this.$emit('resize-form', perc);
    }
  }
});

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g3wform_header box-header with-border",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('section',{staticClass:"g3wform_header_content"},_vm._l((_vm.headers),function(header){return _c('span',{key:header.id,staticClass:"title",class:[{item_selected: _vm.currentid === header.id && _vm.headers.length > 1},[_vm.headers.length > 1 ? 'tabs' : 'one' ]],staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"},style:({fontSize: _vm.isMobile() && '1em !important'}),on:{"click":function($event){$event.stopPropagation();return _vm.click(header.id)}}},[(header.icon)?_c('span',{staticStyle:{"margin-right":"5px"}},[_c('i',{class:header.icon})]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t:pre",value:(header.title),expression:"header.title",arg:"pre"}],staticClass:"g3w-long-text"},[_vm._v(_vm._s(header.name))]),_vm._v(" "),_c(header.component,{tag:"component",attrs:{"valid":_vm.valid,"update":_vm.update}})],1)}),0)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FormHeader.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__